const priceValues = [
    { 
        value: '0', 
        en: 'Max Price', 
        th: 'ราคาสูงสุด', 
        cn: '最高价格', 
        ru: 'Макс. цена', 
        de: 'Maximaler Preis', 
        fr: 'Prix maximum',
        it: 'Prezzo massimo',
        ja: '最高価格',
        ko: '최고 가격',
        es: 'Precio máximo',
        tr: 'Maksimum Fiyat',
        he: 'מחיר מקסימלי',
        ar: 'أقصى سعر'
    },
    '100000', '150000', '250000', '500000', '750000', '1000000', '1250000', '1500000', 
    '1750000', '2000000', '2250000', '2500000', '2750000', '3000000', '3250000', 
    '3500000', '3750000', '4000000', '4500000', '5000000', '5500000', '6000000', 
    '6500000', '7000000', '8000000', '9000000', '10000000', '11000000', '12000000', 
    '13000000', '15000000', '17500000', '20000000', '22500000', '25000000', 
    '30000000', '35000000', '40000000', '60000000', '80000000', '100000000', 
    '150000000', '200000000', '300000000', '500000000'
];

// Add the new locale codes here
const languages = ['en', 'th', 'cn', 'ru', 'de', 'fr', 'ja', 'ko', 'es', 'tr', 'he', 'ar', 'it'];

export const saleMaxPrices = languages.reduce((acc, lang) => {
    acc[lang] = priceValues.map(item => {
        if (typeof item === 'object') {
            return { value: item.value, nom: item[lang] };
        }
        return {
            value: item,
            // Changed 'en-US' to lang to provide localized number formatting
            nom: Number(item).toLocaleString(lang === 'cn' ? 'zh-CN' : lang) 
        };
    });
    return acc;
}, {});